import {JSX} from "react";
import {Navigate, Outlet} from "react-router";
import {useUser} from "../hooks/useUser";

import {PublicRoutes} from "../routes";

export default function PrivateRoute(): JSX.Element {
	const user = useUser();
	if (user.authStatus == "unauthorized") return <Navigate to={PublicRoutes.welcome}/>;
	return <Outlet/>;
}
